import { Typography } from '@vertem-core/vertice-ds';

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const Disclaimer = ({ limits, limitsTax, pointsName, decimalPlaces }) => {
  const disclaimerFile = process.env.REACT_PIX_PAGE_CUSTOM_DISCLAIMER_DATA || 'pix-page-default-disclaimer.js'
  
  const [disclaimerItems, setDisclaimerItems] = useState([]);
  const loadDisclaimerItems = async () => {
    try {
      const module = await import(`../Disclaimer/data/${disclaimerFile}`);
      const getTermsData = module.default;

      const { min: minValue, max:maxValue } = limits;
      const { value: valueTax, isPercentage } = limitsTax;

      setDisclaimerItems(getTermsData(minValue, maxValue, pointsName, decimalPlaces, valueTax, isPercentage));
    } catch (error) {
      console.error("Erro ao carregar os items do Disclaimer:", error);
    }
  };

  useEffect(() => {
    loadDisclaimerItems();
  }, [limits, limitsTax]);

  const filteredItems = disclaimerItems.filter(item => item.enabled);
  const half = Math.ceil(filteredItems.length / 2);

  return (
    <>
      <Typography.Text level={4}>
        Agora você poderá solicitar a transferência dos seus ganhos comerciais diretamente na sua conta bancária.<br />
        <Typography.Text strong>
          A transferência bancária é mais um benefício para você.
        </Typography.Text>
        <br />
      </Typography.Text>
      <br />
      <Typography.Text strong className="typograph-title-pix-page">
        Importante:
      </Typography.Text>
      <br />

      <div className="box-disclaimer-pix-page"
        
      >
        <span 
          

        >
        {filteredItems.slice(0, half)
          .map((item, index) => (
            <Typography.Text
              key={index}
              strong={item.strong}
              className={item.className}
            >
              {index + 1}. {item.text}
              <br />
            </Typography.Text>
          ))}
        </span>

        <span >
          {filteredItems.slice(half)
            .map((item, index) => (
              <Typography.Text
                key={index + half}
                strong={item.strong}
                className={item.className}
              >
                {index + half + 1}. {item.text}
                <br />
              </Typography.Text>
            ))}
        </span>

      </div>
      <Typography.Text strong>
        A responsabilidade pelo envio das informações é do Participante.
      </Typography.Text>
    </>
  );
};

Disclaimer.propTypes = {
  limits: PropTypes.number,
  limitsTax: PropTypes.number,
  pointsName: PropTypes.string,
  decimalPlaces: PropTypes.number,
};

export default Disclaimer;
